import { useRouteNavigation } from "../../../lib/common/routes";
import { TopMenu } from "./top-menu";
import { RouteEnumType } from "../../../lib/types/routes";
import { useUserService } from "../../../services/users";
import { useLocation } from "react-router-dom";
import React, { useEffect, useRef, useState } from "react";
import { evaluators, useWindowSizeMatch } from "../../../lib/window-size-matcher";
import { DEVICES_SIZES_IN_PX } from "../../../lib/common/constants";

const ButtonSignup = ({ title, navigateTo }: { title: string; navigateTo: RouteEnumType }) => {
    const { navigateRouteClickHandler } = useRouteNavigation();
    const isDentalTalentSignup = title === "Dental Talent Sign Up";

    return (
        <button
            className={`btn btn-home-signUp px-5 fw-bold ${isDentalTalentSignup ? " btn-home-signUp_talent text-white border border-0" : "btn-light"}`}
            onClick={(e) => navigateRouteClickHandler(navigateTo, e)}
            title={title}
        >
            {title}
        </button>
    );
};

const SplashScreen = ({ animationEndedHandler }: { animationEndedHandler: () => void }) => {
    const videoEndedHandler = () => {
        (document.getElementById("splashScreen") as HTMLDivElement).classList.add("fade-in-image");
        window.document.body.style.overflow = "auto";
    };
    const { conditionFulfilled: isSmallDevice } = useWindowSizeMatch({
        condition: evaluators.lessThan(DEVICES_SIZES_IN_PX.medium),
    });

    const { conditionFulfilled: isPortrait } = useWindowSizeMatch({
        condition: evaluators.isPortrait(),
    });

    const videoRef = useRef<HTMLVideoElement>(null);
    const buttonContainerRef = useRef<HTMLDivElement>(null);

    const clickPlayVideoHandler = () => {
        if (buttonContainerRef.current) {
            buttonContainerRef.current.style.display = "none";
        }
        videoRef.current?.play();
    };

    useEffect(() => {
        window.document.body.style.overflow = "hidden";
    }, []);

    return (
        <>
            <div id="splashScreen" onAnimationEnd={animationEndedHandler} className="container-video-splash">
                <video
                    ref={videoRef}
                    className="align-middle"
                    playsInline={true}
                    onEnded={videoEndedHandler}
                    style={{
                        width: "100%",
                    }}
                    // autoPlay={true}
                    // muted={true}
                >
                    <source src={!isPortrait.fulfilled ? "/splash_wide.mp4" : isSmallDevice.fulfilled ? "/splash_vertical.mp4" : "/splash_wide.mp4"} />
                </video>
                <div className="play-button" ref={buttonContainerRef}>
                    <button className="btn btn-link" onClick={clickPlayVideoHandler}>
                        <img src="/images/global/play_button.png" alt="play button" />
                    </button>
                </div>
            </div>
        </>
    );
};

export const Intro = () => {
    const search = useLocation().search;
    const showSplash = new URLSearchParams(search).get("showSplash") === "1";

    const { isLoggedIn } = useUserService();
    const [showVideo, setShowVideo] = useState<boolean>(true);
    const { navigateToRoute } = useRouteNavigation();

    const animationEndedHandler = () => {
        setShowVideo((_before) => {
            window.document.body.style.overflow = "auto";
            return false;
        });
        navigateToRoute("home"); //document.getElementById("splashContainer")?.remove();
    };

    return (
        <>
            <div id="splashContainer">{showSplash && showVideo && <SplashScreen animationEndedHandler={animationEndedHandler} />}</div>
            <div className="intro-hero">
                <TopMenu isLandingPage={true} />
                <div className="container-fluid image-section-intro">
                    <div className="container px-4 px-md-5 text-white intro-hero__content position-absolute bottom-0 start-0 end-0">
                        <h1 className="home-title me-4">
                            How <br />
                            <span className="">Dental Talent</span> <br /> Finds Paradise.
                        </h1>
                        <h5 className="intro-hero__copy">
                            WinWinGo is the only comprehensive platform <br className="intro-hero__desktop-break" />
                            matching skilled dental talent with premier dental <br className="intro-hero__desktop-break" />
                            employers in your chosen location. Explore videos, <br className="intro-hero__desktop-break" />
                            local facts, and current events and direct message a <br className="intro-hero__desktop-break" />
                            potential new employer.
                        </h5>
                        {!isLoggedIn && (
                            <div className="my-4">
                                <div className="d-flex flex-column justify-content-start flex-sm-row gap-3 gap-lg-5">
                                    <>
                                        <ButtonSignup title="Dental Talent Sign Up" navigateTo="signupTech" />
                                        <ButtonSignup title="Dental Employer Sign Up" navigateTo="signupLab" />
                                    </>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};
